import { connect } from "react-redux";
import {
  ID,
  PERMISSIONS,
  ROLE,
  ROLES,
  SUBROLE,
  SUBROLES,
  USER
} from "MODULES/users/constants";

function Forbidden({ forbidden, children }) {
  return forbidden ? false : children;
}

export default connect((state, ownProps) => {
  const userRole = state.session.getIn([USER, ROLE]);
  const subRole = state.session.getIn([USER, SUBROLE]);
  const permissions = state.session.getIn([USER, PERMISSIONS]);
  const userId = state.session.getIn([USER, ID]);

  const otherRoles =
    permissions && ownProps.roles
      ? permissions
          .toJS()
          .filter(a => ROLES.includes(a) && !ownProps.roles.includes(a))
      : [];

  const otherRolesNotInSubroles =
    ownProps.subroles &&
    ROLES.filter(a => !ownProps.subroles.some(s => s.includes(a)));

  const otherSubroles =
    permissions && ownProps.subroles
      ? permissions
          .toJS()
          .filter(
            a =>
              (SUBROLES.includes(a) && !ownProps.subroles.includes(a)) ||
              (ROLES.includes(a) && otherRolesNotInSubroles.includes(a))
          )
      : [];

  const hasSubrole =
    ownProps.subroles &&
    ownProps.subroles.includes(subRole) &&
    otherSubroles.length === 0;

  const isBuyerOrCoBuyer =
    ownProps.buyerId === userId || ownProps.coBuyerId === userId;

  return {
    forbidden:
      !isBuyerOrCoBuyer &&
      ((ownProps.roles &&
        ownProps.roles.includes(userRole) &&
        otherRoles.length === 0) ||
        hasSubrole)
  };
})(Forbidden);



// WEBPACK FOOTER //
// ./app/modules/shared/components/Authorized/Forbidden.jsx